import React, { useContext, useMemo } from 'react'
import useConstCallback from './useConstCallback'

interface IMinZIndexContext {
  zIndex: number
}

const MinZIndexContext = React.createContext<IMinZIndexContext>({ zIndex: 0 })

interface IMinZIndexHook {
  ZIndexContextProvider: React.FC
  zIndex: number
}

export default function useMinZIndex(zIndex: number): IMinZIndexHook {
  const parentContext = useContext(MinZIndexContext)
  const childZIndex = Math.max(zIndex, parentContext.zIndex + 1)
  const childContextValue: IMinZIndexContext = useMemo(() => ({ zIndex: childZIndex }), [childZIndex])
  const childWrapper: React.FC = useConstCallback(({ children }) => (
    <MinZIndexContext.Provider value={childContextValue}>{children}</MinZIndexContext.Provider>
  ))

  return {
    ZIndexContextProvider: childWrapper,
    zIndex: childZIndex,
  }
}
